import { useState, useContext } from "react";

import Card from "../../shared/components/UIElements/Card";
import Button from "../../shared/components/FormElements/Button";
import Modal from "../../shared/components/UIElements/Modal";
import Map from "../../shared/components/UIElements/Map";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";

import { AuthContext } from "../../shared/context/auth-context";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { buildApiUrl, buildAssetUrl } from "../../shared/util/url";
import {
    extractCity,
    inferPlaceCategory,
} from "../../shared/util/place-insights";

import "./PlaceItem.css";

const PlaceItem = (props) => {
    const { isLoading, error, sendRequest, clearError } = useHttpClient();

    const auth = useContext(AuthContext);
    const imageUrl = buildAssetUrl(props.image);
    const cityLabel = extractCity(props.address);
    const categoryLabel = inferPlaceCategory({
        title: props.title,
        description: props.description,
        address: props.address,
    });

    const [showMap, setShowMap] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const openMapHandler = () => setShowMap(true);
    const clsoeMapHandler = () => setShowMap(false);

    const showDeleteWarningHandler = () => setShowConfirmModal(true);
    const cancelDeleteHandler = () => setShowConfirmModal(false);
    const confirmDeleteHandler = async () => {
        setShowConfirmModal(false);
        try {
            await sendRequest(
                buildApiUrl(`/places/${props.id}`),
                "DELETE",
                null,
                {
                    Authorization: "Bearer " + auth.token,
                },
            );
            props.onDelete(props.id);
        } catch (err) {}
    };

    return (
        <>
            <ErrorModal error={error} onClear={clearError} />
            <Modal
                show={showMap}
                onCancel={cancelDeleteHandler}
                header={props.address}
                contentClass="place-item__modal-content"
                footerClass="place-item__modal-actions"
                footer={<Button onClick={clsoeMapHandler}>CLOSE</Button>}>
                <div className="map-container">
                    <Map center={props.cordinates} zoom={16} />
                </div>
            </Modal>

            <Modal
                show={showConfirmModal}
                onCancel={props.onCancel}
                header="Are you sure?"
                footerClass="place-item__modal-actions"
                footer={
                    <>
                        <Button inverse onClick={cancelDeleteHandler}>
                            CANCEL
                        </Button>
                        <Button danger onClick={confirmDeleteHandler}>
                            DELETE
                        </Button>
                    </>
                }>
                <p>
                    Do you want to proceed and delete this place? Please note
                    that it can't be undone thereafter
                </p>
            </Modal>

            <li className="place-item">
                <Card className="place-item__content">
                    {isLoading && <LoadingSpinner asOverlay />}
                    <div className="place-item__image">
                        <img src={imageUrl} alt={props.title} />
                        <div className="place-item__chips">
                            <span>{cityLabel}</span>
                            <span>{categoryLabel}</span>
                        </div>
                    </div>
                    <div className="place-item__info">
                        <h2>{props.title}</h2>
                        <h3>{props.address}</h3>
                        <p>{props.description}</p>
                        <div className="place-item__meta">
                            <span>Detailed stop</span>
                            <span>
                                {props.description.length > 50
                                    ? "Rich description"
                                    : "Compact note"}
                            </span>
                        </div>
                    </div>
                    <div className="place-item__actions">
                        <Button inverse onClick={openMapHandler}>
                            VIEW ON MAP
                        </Button>
                        {auth.userId === props.creator && (
                            <Button to={`/places/${props.id}`}>EDIT</Button>
                        )}
                        {auth.userId === props.creator && (
                            <Button danger onClick={showDeleteWarningHandler}>
                                DELETE
                            </Button>
                        )}
                    </div>
                </Card>
            </li>
        </>
    );
};

export default PlaceItem;
